"use strict";
var codemirror_module_1 = require("./codemirror.module");
exports.CodemirrorModule = codemirror_module_1.CodemirrorModule;
var codemirror_component_1 = require("./codemirror.component");
exports.CodemirrorComponent = codemirror_component_1.CodemirrorComponent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-codemirror/lib/index.js
// module id = 489
// module chunks = 4